import { vesselCardStyles } from "../constants/vessel-card-styles.constants";
import { VesselCardTcoRow } from "../models/vessel-card.models";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

interface VesselCardTcoPanelProps {
  rows: VesselCardTcoRow[];
  onReceiveByEmail: () => void;
}

const formatMetric = (value: number | null): string => (value === null ? "—" : value.toFixed(1));

const VesselCardTcoPanel = ({ rows, onReceiveByEmail }: VesselCardTcoPanelProps) => (
  <section data-test="vessel-card-tco-descriptions" className={twMerge(vesselCardStyles.surface, "xl:col-span-5")}>
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <h2 className={vesselCardStyles.sectionTitle}>TCO descriptions</h2>
      <button
        type="button"
        data-test="vessel-card-receive-email-button"
        onClick={onReceiveByEmail}
        className={vesselCardStyles.primaryButton}
      >
        <EnvelopeIcon className="h-5 w-5" />
        Receive by email
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full min-w-[560px] text-sm">
        <thead className="border-y border-gray-200 bg-gray-50 text-xs text-gray-600 dark:border-gray-700 dark:bg-gray-900/50 dark:text-gray-300">
          <tr>
            <th rowSpan={2} className="px-3 py-3 text-left font-semibold">
              Mode
            </th>
            <th colSpan={2} className="px-3 pb-1 pt-3 text-center font-semibold">
              Aggressive (+0.5kn)
            </th>
            <th colSpan={2} className="px-3 pb-1 pt-3 text-center font-semibold">
              Very aggressive (+0.5kn &amp; -5% cons)
            </th>
          </tr>
          <tr>
            {Array.from({ length: 2 }).flatMap((_, groupIndex) =>
              ["Speed", "Cons"].map((label) => (
                <th key={`${groupIndex}-${label}`} className="px-3 pb-3 text-center font-medium">
                  {label}
                </th>
              )),
            )}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
          {rows.map((row) => (
            <tr key={row.mode}>
              <th className="px-3 py-3 text-left font-semibold">{row.mode}</th>
              <td className="px-3 py-3 text-center">{formatMetric(row.aggressiveSpeed)}</td>
              <td className="px-3 py-3 text-center">{formatMetric(row.aggressiveConsumption)}</td>
              <td className="px-3 py-3 text-center">{formatMetric(row.veryAggressiveSpeed)}</td>
              <td className="px-3 py-3 text-center">{formatMetric(row.veryAggressiveConsumption)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);

export default VesselCardTcoPanel;
